
import { css } from 'lit';
export default css`
:host {
  position: absolute;
  top: -1px;
  z-index: -10;
}

  @media screen and (min-width: 1664px) {:host {
    width: calc(1440px + 7em);
    overflow: hidden;
  }
  }

:host([isopen]) {
  height: 100vh;
}

.nav-flyout--closed {
    transform: translateX(-100%);
  }

.nav-flyout--open {
    transform: translateX(0);
  }

.nav-flyout--hidden {
    visibility: hidden;
  }

.nav-flyout__wrapper {
  position: absolute;
}

.nav-flyout__wrapper {
  top: -1px;
}

.nav-flyout__wrapper {
  z-index: -10;
}

.nav-flyout__wrapper {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.nav-flyout__wrapper {
  transition-duration: 300ms;
}

.nav-flyout__wrapper {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

@media (min-width: 1024px) {

  .nav-flyout__wrapper {
    height: 100vh;
  }
}

@media (min-width: 1024px) {

  .nav-flyout__wrapper {
    width: 100vw;
  }
}

@media (min-width: 1024px) {

  .nav-flyout__wrapper {
    --tw-bg-opacity: 1;
    background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
  }
}

@media (min-width: 1024px) {

  .nav-flyout__wrapper {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }
}

@media (min-width: 1024px) {

  .nav-flyout__wrapper {
    padding-left: 8.5rem;
  }
}

@media (min-width: 1024px) {

  .nav-flyout__wrapper {
    padding-right: 2rem;
  }
}

@media (min-width: 1200px) {

  .nav-flyout__wrapper {
    padding-left: 10rem;
  }
}

.nav-flyout__wrapper {

    max-height: calc(101vh - var(--topAlign));
  }

@media screen and (min-width: 1664px) {

.nav-flyout__wrapper {
      width: calc(1440px + 7em);
      padding-left: 17rem;
      padding-right: 14rem
  }
    }

.nav-flyout__header {
  display: flex;
}

.nav-flyout__header {
  justify-content: space-between;
}

.nav-flyout__logo-wrapper {
  margin: 0.75rem;
}

.nav-flyout__logo-wrapper {
  height: 100%;
}

.nav-flyout__logo-wrapper {
  width: 12rem;
}

.nav-flyout__logo-wrapper {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

@media (min-width: 1024px) {

  .nav-flyout__logo-wrapper {
    margin-left: 2.5rem;
  }
}

@media (min-width: 1024px) {

  .nav-flyout__logo-wrapper {
    padding-top: 0.25rem;
  }
}

.nav-flyout__search {
  margin-left: 4rem;
}

.nav-flyout__search {
  width: 40rem;
}

.nav-flyout__search {
    display: none;
  }

.nav-flyout__links-wrapper {
  margin-top: 6rem;
}

.nav-flyout__links-wrapper {
  display: flex;
}

.nav-flyout__links-wrapper {
  flex-direction: row;
}

.nav-flyout__links-wrapper {
  align-items: center;
}

.nav-flyout__links-wrapper {
  justify-content: center;
}

.nav-flyout__prime-links-wrapper {
  margin: 0px;
}

.nav-flyout__prime-links-wrapper {
  margin-right: 6rem;
}

.nav-flyout__sub-links-wrapper {
  border-left-width: 1px;
}

.nav-flyout__sub-links-wrapper {
  --tw-border-opacity: 1;
  border-color: rgba(109, 89, 149, var(--tw-border-opacity));
}

.nav-flyout__prime-links-item {
  border-bottom-width: 1px;
}

.nav-flyout__prime-links-item {
  --tw-border-opacity: 1;
  border-color: rgba(109, 89, 149, var(--tw-border-opacity));
}

.nav-flyout__prime-links-item {
  font-weight: 700;
}

.nav-flyout__prime-links-item {
    font-size: 2.25rem;
  }

.nav-flyout__prime-links-item:last-child {
  border-bottom-width: 0px;
}

.nav-flyout__link {
  display: block;
}

.nav-flyout__link {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.nav-flyout__link:hover {
  text-decoration: underline;
}

.nav-flyout__sub-link {
  margin-left: -2px;
}

.nav-flyout__sub-link {
  display: inline-block;
}

.nav-flyout__sub-link {
  border-left-width: 3px;
}

.nav-flyout__sub-link {
  border-color: transparent;
}

.nav-flyout__sub-link {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.nav-flyout__sub-link {
  padding-left: 2.5rem;
}

.nav-flyout__sub-link {
  font-size: 1.25rem;
}

.nav-flyout__sub-link {
  font-weight: 900;
}

.nav-flyout__sub-link:hover {
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
}

.nav-flyout__sub-link:hover {
  text-decoration: underline;
}

.nav-flyout__icon {
    display: none;
  }

@media (min-width: 1024px) {

.nav-flyout__icon {
      display: flex;
      height: 30%;
      position: absolute;
      bottom: -1%;
      fill: white;
      justify-content: end;
      right: 10%
  }
    }
`;